import React from 'react'
import Select from 'react-select'
import RenderValidateMessage from '../Validation/RenderValidateMessage';
import { Form } from 'react-bootstrap'

export default function GenderInput(props) {
    const { 
        errors, 
        value, 
        setValue, 
        handleEnter, 
        required = false,
        genderOptions = [
            { value: 'm', label: 'Male' },
            { value: 'f', label: 'Female' },
            { value: 'o', label: 'Other' }
        ] 
    } = props;

    const selected = genderOptions.find((option) => {
        return option.value === value
    });

    return (
        <Form.Group>
            <Form.Label>{required && <span className="text-danger">*</span>} Gender</Form.Label>
            <Select
                value={selected || ''}
                options={genderOptions}
                onChange={e => setValue({ gender: e.value })}
                onKeyDown={handleEnter}
            />
            <RenderValidateMessage errors={errors} field="gender" />
        </Form.Group>
    )
}
